import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Handshake, Scale } from "lucide-react";

const collaborators = [
  {
    name: "Colegiul Consilierilor Juridici Ilfov",
    short: "CCJ Ilfov",
    type: "Asociație profesională",
    logo: "/assets/ccj-ilfov-logo.png",
    site: "https://ccjilfov.ro",
    siteLabel: "ccjilfov.ro",
    description:
      "Asociație profesională a consilierilor juridici, constituită în baza Legii nr. 514/2003 în luna iunie 2011. Colegiul reunește profesioniști ai dreptului din județul Ilfov și din zona Bucureștiului, organizând examene de primire în profesie, adunări generale, dezbateri și conferințe dedicate organizării și exercitării unitare a profesiei de consilier juridic în România.",
    areas: [
      "Dezbateri și conferințe juridice",
      "Comunicări științifice comune",
      "Sprijin în organizarea evenimentelor asociației",
    ],
    testid: "collaborator-ccj-ilfov",
  },
];

const Collaborators = () => {
  return (
    <div data-testid="collaborators-page">
      {/* HERO */}
      <section className="max-w-[1280px] mx-auto px-6 lg:px-12 pt-16 pb-12" data-testid="collaborators-hero">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[color:var(--ink-soft)] hover:text-[color:var(--gold)]"
          data-testid="collaborators-back-link"
        >
          <ArrowLeft size={14} /> Înapoi la pagina principală
        </Link>

        <div className="grid lg:grid-cols-12 gap-12 items-end mt-10">
          <div className="lg:col-span-8 fade-in">
            <div className="eyebrow" data-testid="collaborators-eyebrow">Parteneriate</div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.04]" data-testid="collaborators-title">
              Colaboratorii<br />
              <span className="font-display-italic text-[color:var(--gold)]">asociației noastre.</span>
            </h1>
          </div>
          <div className="lg:col-span-4 fade-in delay-2">
            <p className="text-[color:var(--ink-soft)] leading-relaxed">
              Instituții, asociații profesionale și organizații care sprijină demersurile
              culturale, științifice și diplomatice ale Asociației General George Pomuț.
            </p>
          </div>
        </div>
      </section>

      <div className="rule max-w-[1280px] mx-auto" />

      {/* LISTA COLABORATORI */}
      <section className="max-w-[1280px] mx-auto px-6 lg:px-12 py-16" data-testid="collaborators-list">
        <div className="space-y-12">
          {collaborators.map((c) => (
            <article
              key={c.name}
              className="gold-border bg-[color:var(--cream)]/60 p-8 sm:p-12 fade-in"
              data-testid={c.testid}
            >
              <div className="grid lg:grid-cols-12 gap-10 items-start">
                <div className="lg:col-span-3 flex lg:block justify-start">
                  <div className="bg-[color:var(--ivory)] border border-[color:var(--line)]/40 p-6 inline-flex items-center justify-center w-full max-w-[220px]">
                    <img
                      src={c.logo}
                      alt={`Sigla ${c.name}`}
                      className="w-[120px] h-auto"
                      loading="lazy"
                      data-testid={`${c.testid}-logo`}
                    />
                  </div>
                </div>

                <div className="lg:col-span-9">
                  <div className="flex items-center gap-3">
                    <Scale size={16} className="text-[color:var(--gold)]" />
                    <span className="text-[11px] uppercase tracking-[0.22em] text-[color:var(--ink-soft)]">
                      {c.type}
                    </span>
                  </div>

                  <h2 className="font-display text-3xl sm:text-4xl mt-4 leading-tight text-[color:var(--ink)]">
                    {c.name}
                  </h2>

                  <p className="mt-5 text-[16px] leading-[1.8] text-[color:var(--ink-soft)] max-w-3xl">
                    {c.description}
                  </p>

                  {c.areas?.length > 0 && (
                    <div className="mt-8">
                      <div className="eyebrow">Direcții de colaborare</div>
                      <ul className="mt-4 space-y-2">
                        {c.areas.map((a) => (
                          <li key={a} className="flex items-start gap-3 text-[15px] text-[color:var(--ink-soft)]">
                            <Handshake size={15} className="text-[color:var(--gold)] mt-1 shrink-0" />
                            <span>{a}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <a
                    href={c.site}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-primary mt-9"
                    data-testid={`${c.testid}-site-link`}
                  >
                    Vizitați {c.siteLabel} <ArrowUpRight size={16} />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* INVITAȚIE COLABORARE */}
      <section className="ink-bg" data-testid="collaborators-invitation">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12 py-20 grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="eyebrow text-[color:var(--gold-soft)]">Deschidere</div>
            <h2 className="font-display text-3xl md:text-4xl mt-4 text-[color:var(--ivory)] leading-[1.1]">
              Suntem deschiși către noi{" "}
              <span className="font-display-italic text-[color:var(--gold-soft)]">parteneriate instituționale.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[color:var(--cream)]/70 leading-relaxed text-sm">
              Instituțiile academice, asociațiile profesionale și organizațiile culturale
              interesate de recuperarea memoriei generalului George Pomuț și de proiectele
              noastre științifice și diplomatice ne pot contacta la Oradea, județul Bihor.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Collaborators;
